// Valores por defecto de rulesPictogramsSga.
export const defaultRulesPictogramsSga = () => {
    return [];
};

// Valor por defecto de action.
export const defaultActionRulePictogram = () => {
    return "";
};

// Valor por defecto de rulePictogram.
export const defaultRulePictogram = () => {
    return {
        id: null,
        name: null,
        sga_pictogram_combination_ids: [],
        sga_pictograms_to_display_ids: [],
    };
};

// Valores por defecto de filterRulesPictogramsSga.
export const defaultFilterRulesPictogramsSga = () => {
    return {
        name: null,
        is_active: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

export default {
    rulesPictogramsSga: defaultRulesPictogramsSga(),
    action: defaultActionRulePictogram(),
    rulePictogram: defaultRulePictogram(),
    filterRulesPictogramsSga: defaultFilterRulesPictogramsSga(),
};
